// Permisos RBAC de Promociones, ENCENDIDOS: sin las claves sembradas la pantalla se esconde
// (fail-closed). Eso es lo correcto, no un bug del front.

/**
 * Claves de permiso del dominio de promociones. Van como `string` y no como `Permission` porque
 * `PermissionKey` (generado del OpenAPI del rbac) hoy no expone ninguna clave de dominio.
 *
 * `publish` es su propia clave y no se cuelga de `update`: publicar, pausar, reanudar y vencer son
 * las acciones que mueven dinero, y quien redacta un borrador no es necesariamente quien lo prende.
 */
export const PROMOTIONS_PERMISSIONS = {
    read: 'loan.promotion.read',
    create: 'loan.promotion.create',
    update: 'loan.promotion.update',
    publish: 'loan.promotion.publish',
} as const;

export type PromotionsPermissionKey =
    (typeof PROMOTIONS_PERMISSIONS)[keyof typeof PROMOTIONS_PERMISSIONS];

/** El gate está encendido: sin la clave la pantalla se esconde (fail-closed). */
export const PROMOTIONS_PERMISSIONS_ENFORCED = true;

export interface PromotionsAbilities {
    canRead: boolean;
    canCreate: boolean;
    canUpdate: boolean;
    canPublish: boolean;
}

/** Con `enforce: false` todo queda permitido; con `true` cada acción exige su clave. */
export function resolvePromotionsAbilities(
    grantedPermissions: ReadonlySet<string>,
    enforce: boolean = PROMOTIONS_PERMISSIONS_ENFORCED,
): PromotionsAbilities {
    if (!enforce) {
        return { canRead: true, canCreate: true, canUpdate: true, canPublish: true };
    }
    return {
        canRead: grantedPermissions.has(PROMOTIONS_PERMISSIONS.read),
        canCreate: grantedPermissions.has(PROMOTIONS_PERMISSIONS.create),
        canUpdate: grantedPermissions.has(PROMOTIONS_PERMISSIONS.update),
        canPublish: grantedPermissions.has(PROMOTIONS_PERMISSIONS.publish),
    };
}
